import { Component, Input, OnInit } from '@angular/core';
import { SearchFacetValueNode } from '../../../api/models/search-facet-value-node';
import { SearchFacetValue } from '../../../api/models/search-facet-value';
import { SearchEventTypeEnum } from '../../../shared/model/search-event-type-enum';
import { SearchEventPublisher } from '../../../shared/service/search-event-publisher.service';
import { AnalyticsService } from 'src/app/shared/service/analytics/analytics.service';
import { FacetData, SearchResult } from 'src/app/api/models';
import { FacetDataHolderService } from '../../../shared/service/facet-data-holder.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@Component({
  selector: 'app-secondary-navigation-dropdown',
  templateUrl: './secondary-navigation-dropdown.component.html',
  styleUrls: ['./secondary-navigation-dropdown.component.scss'],
})
@UntilDestroy()
export class SecondaryNavigationDropdownComponent implements OnInit {
  @Input()
  searchFacetValueNode!: SearchFacetValueNode;

  @Input()
  searchResult?: SearchResult;

  isOpen: boolean = false;
  facetData?: FacetData;

  constructor(private searchEventPublisher: SearchEventPublisher,
              private analyticsService: AnalyticsService,
              private facetDataHolder: FacetDataHolderService) {
  }

  ngOnInit() {
    this.facetDataHolder.getFacetData()
      .pipe(untilDestroyed(this))
      .subscribe(fd => this.facetData = fd);
  }

  narrowByFacet(facet: SearchFacetValue) {
    this.searchEventPublisher.publishEvent(SearchEventTypeEnum.NARROW_BY_FACET, facet.params);
    this.analyticsService.trackNavigationChange(facet.params.sn, this.facetData?.facetCodeNameMap, this.facetData?.facetValueCodeNameMap, facet.englishDisplayString);
    this.closeDropdown();
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }
}
